import React from 'react'

export const LightboxContext = React.createContext({})
